import { Box, Stack, Text } from '@mantine/core';

interface PayloadType {
  value: number;
  color: string;
  dataKey: string;
}

interface CustomTooltipProps {
  active?: boolean;
  label?: string;
  payload?: PayloadType[];

  text: Record<string, string>;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, label, payload, text }) => {
  if (active && payload && payload.length) {
    return (
      <Box className="bg-white px-5 py-3 border border-gray-200 rounded-xl">
        <Stack gap={'xs'}>
          <Text>{label}</Text>
          {payload.map((item, index) => (
            <Text key={index} style={{ color: item.color }}>
              {text[item.dataKey]}: {item.value}
            </Text>
          ))}
        </Stack>
      </Box>
    );
  }

  return null;
};

export default CustomTooltip;
